var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClinicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#60CAC1",
    strokeWidth: 3,
    d: "M52.5 55V21.25c0-3.511 0-5.267-.843-6.528a5 5 0 0 0-1.38-1.38c-1.26-.842-3.016-.842-6.527-.842M7.5 55V21.25c0-3.511 0-5.267.843-6.528a5 5 0 0 1 1.38-1.38c1.26-.842 3.016-.842 6.527-.842"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#60CAC1",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M13.75 27.5h3.75M13.75 35h3.75M13.75 20h3.75M42.5 27.5h3.75M42.5 35h3.75M42.5 20h3.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0A579A",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M55 55H5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0A579A",
    strokeWidth: 3,
    d: "M42.5 55V15c0-4.714 0-7.071-1.465-8.536C39.572 5 37.215 5 32.5 5h-5c-4.714 0-7.071 0-8.535 1.464C17.5 7.93 17.5 10.286 17.5 15v40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0A579A",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M30 55v-7.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#60CAC1",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M25 30h10M25 37.5h10",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0A579A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M30 22.5v-10M35 17.5H25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicIcon);
export default __webpack_public_path__ + "static/media/clinicIcon.632ccb5031d370af12e0f2be156a16c3.svg";
export { ForwardRef as ReactComponent };